import React from 'react';
import { CheckCircle, Users, Clock, MapPin } from 'lucide-react';
import { whyChooseUs } from '../data/mock';

const icons = [Users, CheckCircle, Clock, MapPin];

const serviceAreas = [
  'Franklin',
  'Madison',
  'Delaware',
  'Fairfield',
  'Pickaway'
];

const WhyChooseUsSection = () => {
  return (
    <section id="why-us" className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {/* Left Content */}
          <div>
            <span
              className="inline-block px-4 py-2 rounded-full text-sm font-medium mb-4"
              style={{ background: 'rgba(217, 179, 217, 0.3)', color: '#c49bc4' }}
            >
              Why Choose Us
            </span>

            <h2
              className="text-3xl sm:text-4xl font-display font-semibold mb-6"
              style={{ color: '#c49bc4' }}
            >
              Trusted Care for Your Family
            </h2>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              At A Gentle Touch HomeCare, we understand that choosing a care provider is one of the
              most important decisions you&apos;ll make. Here&apos;s why families across Ohio trust us.
            </p>

            <div className="space-y-6">
              {whyChooseUs.map((item, index) => {
                const Icon = icons[index];
                return (
                  <div key={index} className="flex gap-4">
                    <div
                      className="flex-shrink-0 w-12 h-12 rounded-xl flex items-center justify-center"
                      style={{ background: 'rgba(0, 128, 128, 0.1)' }}
                    >
                      <Icon className="w-6 h-6" style={{ color: '#008080' }} />
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900 mb-1">
                        {item.title}
                      </h4>
                      <p className="text-gray-600 text-sm leading-relaxed">
                        {item.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Content – Service Areas */}
          <div className="service-area-map">
            <div className="mb-6 text-center">
              <MapPin
                className="w-16 h-16 mx-auto mb-4"
                style={{ color: '#008080' }}
              />
              <h3
                className="text-2xl font-display font-semibold mb-2"
                style={{ color: '#c49bc4' }}
              >
                Serving Ohio
              </h3>
              <p className="text-gray-600 mb-6">
                Proudly providing compassionate in home care to families throughout Central Ohio. Serving Franklin, Madison, Delaware, Fairfield, and Pickaway counties.
              </p>
            </div>

            {/* City Bubbles */}
            <div className="flex flex-wrap justify-center gap-3">
              {serviceAreas.map((city, index) => (
                <span
                  key={index}
                  className="px-4 py-2 rounded-full text-sm font-medium"
                  style={{
                    background: 'rgba(196, 165, 126, 0.15)',
                    color: '#6b5b4d'
                  }}
                >
                  {city}
                </span>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
